import { ControlledForm, ControlledTable } from "Components";
import { FormDataType } from "DataTypes/Form";
import { columnType } from "DataTypes/Table";

export interface PlanDataType {
  id: number;
  text: string;
  category: "goals" | "intervention"
}

export const Arr = [ControlledForm.FormData.AddNotes()];

export const Arr1: FormDataType[] = [
  ControlledForm.FormData.Callfreq(),
  ControlledForm.FormData.CompletionDate(),
];

export const Arr3 = [ControlledForm.FormData.AddNotes()];

export const Arr2: FormDataType[] = [
  {
    id: "interactive",
    label: "Was interactive communication done with the Patient?",
    placeholder: "Select an option",
    boxType: "empty-block",
    boxSize: 3,
    validatetype: "dropdown",
    dropArr: [
      { id: "Yes", label: "Yes", value: "Yes" },
      { id: "No", label: "No", value: "No" },
    ],
  },
  {
    id: "medically",
    label:
      "Are RPM Services medically reasonable & necessary for this patient?",
    placeholder: "Select an option",
    boxType: "empty-block",
    boxSize: 3,
    validatetype: "dropdown",
    dropArr: [
      { id: "Yes", label: "Yes", value: "Yes" },
      { id: "No", label: "No", value: "No" },
    ],
  },
];

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.ProblemCol(),
  ControlledTable.ColumnData.GoalCol(),
  ControlledTable.ColumnData.InterventionCol(),
];
export const TCMTableCol: columnType[] = [
  ControlledTable.ColumnData.TcmProblemCol(),
  ControlledTable.ColumnData.TcmQuesCol(),
  //Separate column for tcm question in summary screen
];

export const RecurringCol: columnType[] = [
  ControlledTable.ColumnData.QuesAnsCol(),
];

export const PlanData: PlanDataType[] = [
  {
    id: 1,
    text: "Reduce or eliminate symptoms of respiratory distress and do yoga.",
    category: "goals"
  },
  {
    id: 2,
    text: "Fewer exacerbations and flares.",
    category: "goals"
  },
  {
    id: 3,
    text: "Avoid triggers that precipitate symptoms.",
    category: "goals"
  },
  {
    id: 4,
    text: "Decrease the need of fast-acting medications.",
    category: "goals"
  },
  {
    id: 5,
    text: "Minimize medication adverse effects.",
    category: "goals"
  },
  {
    id: 6,
    text: "Adhere to take medications, including" +
      " inhalers and nebulizers as prescribed.",
    category: "intervention"
  },
  {
    id: 7,
    text: "Avoid heat and humidity as much as possible.",
    category: "intervention"
  },
  {
    id: 8,
    text: "Smoking Cessation.",
    category: "intervention"
  },
  {
    id: 9,
    text: "Manage stress and excercise as tolarated.",
    category: "intervention"
  },
  {
    id: 10,
    text: "Monitor for symptoms of chest pain, wheezing" +
      " with exertion, at rest or when lying down cough.",
    category: "intervention"
  },
  {
    id: 11,
    text: "Check pulse oximeter at home as directed, alert" +
      " provider if any changes in normal readings.",
    category: "intervention"
  }
]
